import BaseApi from "../base";

export default class ErCall extends BaseApi {

}

